export const familiesTransformer = (serverData, locale) => {
  const yesValue = locale === "et" ? "Jah" : "Yes";
  const noValue = locale === "et" ? "Ei" : "No";

  return {
    id: serverData.id,
    name: serverData.name,
    description: serverData.desc || "",
    bio: serverData.bio || "",
    uniqueProperties: serverData.uniqueProperties || "",
    tags: serverData.tags || "",
    subcategory: serverData.subcategory?.value?.name || null,
    category: serverData.subcategory?.value?.category?.value || null,
    factory: serverData.factory?.value?.name || null,
    factoryUrl: serverData.urlOnFactorySite || null,
    inActiveSale: serverData.inActiveSale ? yesValue : noValue,
    inActiveProduction: serverData.inActiveProduction ? yesValue : noValue,
    owner: {
      name: `${serverData.owner?.value?.firstName || ""} ${
        serverData.owner?.value?.lastName || ""
      }`,
      email: serverData.owner?.value?.email || "",
    },
    usages: serverData.usages?.map((usage) => usage.value?.name || "") || [],
    featureSets:
      serverData.featureSets?.map((featureSet) => ({
        id: featureSet.value?.id,
        name: featureSet.value?.name,
      })) || [],
    featuresArray:
      serverData.featuresArray?.map((feature) => ({
        name: feature.feature?.name || feature.featureName || "Unnamed Feature",
        value:
          feature.featureValue !== undefined
            ? feature.featureValue
            : "value not provided",
      })) || [],
    albums:
      serverData.albums?.map((album) => ({
        id: album.value?.id,
        name: album.value?.name || "",
        media: album.value?.media || [],
      })) || [],
    createdBy: {
      name: `${serverData.createdBy?.value?.firstName || ""} ${
        serverData.createdBy?.value?.lastName || ""
      }`,
      email: serverData.createdBy?.value?.email || "",
    },
    updatedBy: {
      name: `${serverData.updatedBy?.value?.firstName || ""} ${
        serverData.updatedBy?.value?.lastName || ""
      }`,
      email: serverData.updatedBy?.value?.email || "",
    },
  };
};
